export default "__VITE_ASSET__CX25Wtul__"